import type { StarfishIconRef } from './starfish';

/**
 * Promotion glyphs drawn in their own promotion colour rather than an icon token.
 *
 * No icon token covers this colour. It is the design tokens' common colour
 * `colors-fs-primary`, which is the same for every brand, so a literal does not
 * leak one brand's palette into another. (MyPrice has no Starfish glyph: its
 * person-and-tag logo stays a local asset.)
 *
 * Kept free of `'use client'` so that server-side filter builders can import it.
 */
export const FLASH_SALES_ICON: StarfishIconRef = {
  category: 'Brands and products',
  name: 'icon-flash-sales',
  color: '#FFB511',
};

/**
 * The size to draw the flash-sales glyph at so it carries the ink the local asset had in a
 * `box`-pixel slot. That asset filled its box edge to edge; the Starfish glyph spans 20 of its 24
 * grid units, so it is drawn 1.2x bigger and the slot kept with a footprint.
 */
export const flashSalesIconSize = (box: number): number => Math.round((box * 24) / 20);

/**
 * The same for the lastminute deals glyph: the local asset filled its box edge to edge and the
 * Starfish glyph spans 22 of its 24 grid units.
 */
export const lastMinuteDealsIconSize = (box: number): number => Math.round((box * 24) / 22);
